// API/ChatGPT photographic sources and prebuilt photographic compositions only.
import library from './sylvetteLibrary.json';
export const SYLVETTE_DEFAULTS = {
  front_fabric: 'teal-minkee', back_fabric: 'blue-flowers',
  ribbon_fabric: 'pastel-flowers', ribbon: 'gold',
};

export function sylvettePhoto(fabric, ribbon, view = 'front') {
  const requested = fabric?.option_id;
  const isMinky = view === 'front' || fabric?.material === 'minky' || requested?.endsWith('-minkee');
  const fabrics = isMinky ? library.colors : library.liberty;
  const ribbonId = library.ribbons.includes(ribbon?.option_id) ? ribbon.option_id : 'pastel-flowers';
  const referenceBody = isMinky ? 'teal-minkee' : 'pastel-flowers';
  // A catalogue option may not have a reviewed photo yet. Describe the actual
  // reference shown, never inherit a rejected v2 photo or recolour it in CSS.
  const candidates = [[requested,ribbonId],[requested,'pastel-flowers'],[referenceBody,ribbonId],[referenceBody,'pastel-flowers']];
  const [body, shownRibbon] = candidates.find(([id, loop]) => library.combinations[`${view}:${id}:${loop}`]) || [referenceBody,'pastel-flowers'];
  const src = library.combinations[`${view}:${body}:${shownRibbon}`];
  const name = fabrics[body]?.name || 'Bleu canard';
  const ribbonName = library.liberty[shownRibbon]?.name || 'Jardin pastel';
  const exact = body === requested && shownRibbon === ribbon?.option_id && Boolean(src);
  return {
    src, colorName: name, exact, width: library.dimensions?.width || 1254, height: library.dimensions?.height || 1254,
    description: `Sylvette, ${view === 'back' ? 'dos' : 'devant'} ${name}, ruban ${ribbonName}${view === 'front' ? ', visage brodé original' : ', sans visage'}`,
    note: exact ? 'Photo générée · teintes et placement des motifs indicatifs.'
      : `Photo de référence : ${view === 'back' ? 'dos' : 'devant'} ${name}, ruban ${ribbonName}. Le visuel de cette combinaison reste à préparer ; vos choix sont conservés.`,
  };
}
